// @ts-nocheck
import React, { useRef } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, Button } from "antd";
import axios from "axios";
import { CREATE_MAPPING } from "../../util";

const { Dragger } = Upload;

const UploadJson = ({ connectionId, fetchMappings, fetchData, onClose }) => {
  const fileInputRef = useRef(null); // Create a ref for the hidden file input

  const handleFileUpload = async (file) => {
    const reader = new FileReader();
    if (file.type !== "application/json") {
      message.error("Please upload a valid JSON file.");
      return; // Exit the function if the file is not a JSON
    }
    reader.onload = async (e) => {
      try {
        const data = JSON.parse(e.target.result); // Parse the JSON file

        // Check if data is an array
        if (!Array.isArray(data)) {
          throw new Error("Uploaded JSON is not an array.");
        }

        // Map through the JSON array and send each object to the API
        await Promise.all(
          data.map(async (item) => {
            const response = await axios.post(CREATE_MAPPING, {
              ...item,
              connectionId: connectionId.id, // Include the connection ID
            });
            return response.data; // Optionally handle the response if needed
          })
        );

        message.success("All JSON data uploaded successfully!");
        fetchMappings(connectionId.id); // Refresh the mappings
        onClose();
        fetchData(); // Fetch additional data if needed
      } catch (error) {
        message.error(
          `Upload failed: ${error.message || "Invalid JSON file."}`
        );
      }
    };
    reader.readAsText(file); // Read the file as text
  };

  return (
    <div>
      <Dragger
        name="file"
        multiple={false}
        showUploadList={false} // Hide default upload list
        beforeUpload={(file) => {
          handleFileUpload(file); // Call file upload handler
          return false; // Prevent automatic upload behavior
        }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single upload. Strictly prohibited from uploading
          company data or other banned files.
        </p>
      </Dragger>
      <input
        type="file"
        accept=".json"
        style={{ display: "none" }} // Hide the input
        ref={fileInputRef}
        onChange={(e) => {
          const file = e.target.files[0]; // Get the selected file
          if (file) {
            handleFileUpload(file); // Process the file
          }
        }}
      />
    </div>
  );
};

export default UploadJson;
